import React, { useRef, useState } from "react";

import "./sign-request-by-volume-signers-list.css";
import { ButtonHLPure } from "../../pures";
import SignRequestByVolumeSignersListViewPanelPure from "../../pures/sign-request-by-volume-signers-list-panel/sign-request-by-volume-signers-list-panel.pure";

const SignRequestByVolumeSignersListView = (props) => {
  const [allFilesUploaded, setAllFilesUploaded] = useState(true);
  const [pdfFilesFlag, setPdfFilesFlag] = useState(false);

  const {
    step,
    onHandleBack,
    onHandleNext,
    csvJson,
    handleFiles,
    handleDeleteRecord,
  } = props;
  const { next, back, load } = step;
  const filesRef = useRef(null);

  const handleLoad = () => {
    filesRef.current.click();
  };

  const handleOnChange = (e) => {
    handleFiles(e.target.files);
    setPdfFilesFlag(true);
  };

  return (
    <div className="signRequestByVolumeSignersListView-card-description-reliable">
      <input
        type="file"
        multiple
        id="file"
        ref={filesRef}
        accept="application/pdf"
        onChange={handleOnChange}
        style={{ display: "none" }}
      />
      <SignRequestByVolumeSignersListViewPanelPure
        csvJsonArray={csvJson}
        pdfFiles={props.selectedFiles}
        selectedFilesBase64={props.selectedFilesBase64}
        handleDeleteRecord={handleDeleteRecord}
        setAllFilesUploaded={() => setAllFilesUploaded(!allFilesUploaded)}
        {...props}
      />
      <div className="signRequestByVolumeSignersListView-container-btns">
        <ButtonHLPure
          nameBtn={back}
          primary={false}
          onClickBtn={(e) => onHandleBack(e)}
        />
        <ButtonHLPure
          nameBtn={load}
          primary={false}
          onClickBtn={(event) => handleLoad(event)}
        />
        <ButtonHLPure
          nameBtn={next}
          primary={true}
          onClickBtn={(event) => onHandleNext(event)}
          disabled={allFilesUploaded || !pdfFilesFlag}
        />
      </div>
    </div>
  );
};

export default SignRequestByVolumeSignersListView;
